import * as React from 'react';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import {Grid} from "@mui/material";
import ChangePassword from "./Tabs/ChangePassword/ChangePassword";
import {fnLocalizeFilter} from "../../../services/localize.service";
import {useGlobalContext} from "../../../services/context.service";
import ChangeUser from "./Tabs/User/ChangeUser";
import {holderAPI} from "../../../services/holderAPI.service";
import InnerContainer from "../../Common/InnerContainer";
import ApiKey from "./Tabs/ApiKey/ApiKey";
import {useEffect} from "react";

export default function Setting() {
    const {locale} = useGlobalContext();
    const [value, setValue] = React.useState('1');
    holderAPI.useFetchAllClientsQuery({locale});

    const [showApiKey, setShowApiKey] = React.useState(false);

    const getConfig = async () => {
        const setting = await fetch('config.json').then(function (response) {
            return response.json();
        });
        setShowApiKey(!!setting.config.showPublicApiKey);
    };

    useEffect(() => {
        getConfig().then();
    }, [])

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };
    return <>
        <InnerContainer direction={'left'} show={true}>
            <Grid item xs={2}>
                <TabContext value={value}>
                    <TabList onChange={handleChange} aria-label="lab API tabs example">
                        <Tab label={fnLocalizeFilter(locale, '_lang.module.setting.titleChangePass')} value="1"/>
                        <Tab label={fnLocalizeFilter(locale, '_lang.module.setting.titleChangeUser')} value="2"/>
                        {showApiKey && <Tab label="API" value="3"/>}
                    </TabList>
                    <TabPanel value="1">
                        <ChangePassword/>
                    </TabPanel>
                    <TabPanel value="2">
                        <ChangeUser/>
                    </TabPanel>
                    <TabPanel value="3">
                        <ApiKey/>
                    </TabPanel>
                </TabContext>
            </Grid>
        </InnerContainer>
    </>
}
